const SECTION_LINK_IDS = {
  "built-for-talent": "for-talent-link",
  "built-for-hiring-teams": "for-recruiters-link",
  "how-it-works": "how-it-works-link",
  faq: "faq-link",
};

export const navItemHighlighter = (isAnotherPage, href) => {
  Object.values(SECTION_LINK_IDS).forEach((id) => {
    document.getElementById(id)?.classList.remove("active");
  });
  document.getElementById("why-we-built-link")?.classList.remove("active");
  document.getElementById("news-letter")?.classList.remove("active");
  document.getElementById("privacy-policy")?.classList.remove("active");

  if (isAnotherPage) {
    if (href === "/newsletter") {
      document.getElementById("news-letter")?.classList.add("active");
    } else if (href === "/privacy-policy") {
      document.getElementById("privacy-policy")?.classList.add("active");
    } else if (href === "/about") {
      document.getElementById("why-we-built-link")?.classList.add("active");
    }
    return;
  }

  const linkId = SECTION_LINK_IDS[href];
  if (linkId) {
    document.getElementById(linkId)?.classList.add("active");
  }
};
